// MODÜL 6: MÜLAKAT PSİKOLOJİSİ - ZENGİN İÇERİK

const cabinCrewContentsM6Extra = {
  // ==================== ÜNİTE 3: ÖZGÜVEN GELİŞTİRME ====================
  'CM-M6-U3-L1': {
    lesson_id: 'CM-M6-U3-L1',
    title: 'Özgüven Nedir?',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Mülakatta Özgüven',
      paragraphs: [
        'Özgüven = Kendine güvenmek, yeteneklerine inanmak. Ama kibir DEĞİL!',
        'Özgüvenli görünüm: Dik duruş, göz teması, sakin ses tonu, el hareketleri kontrollü.',
        'Özgüvensiz görünüm: Öne eğik, gözler kaçırıyor, titrek ses, çok hızlı konuşma.',
        'Kibirli görünüm: Çok geriye yaslanmak, tepeden bakmak, başkalarını kesmek.',
        'İdeal: Sakin, kontrollü, mütevazı ama kendinden emin. "Ben bu işi yapabilirim" mesajı.'
      ],
      keyPoints: [
        'Özgüven ≠ Kibir',
        'Dik duruş + göz teması',
        'Sakin ve kontrollü ses',
        'Mütevazı ama emin'
      ]
    }
  },
  'CM-M6-U3-L2': {
    lesson_id: 'CM-M6-U3-L2',
    title: 'Sahte Özgüven vs Gerçek Özgüven',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Gerçek Özgüven Nasıl Olur?',
      paragraphs: [
        'SAHTE ÖZGÜVEN: "Ben her şeyi yapabilirim" demek. Gerçekçi değil.',
        'GERÇEK ÖZGÜVEN: "Bu konuda deneyimim var ve öğrenmeye açığım" demek.',
        'Sahte özgüvenin belirtileri: Abartılı iddialar, başkalarını küçümseme, hata kabul etmeme.',
        'Gerçek özgüvenin belirtileri: Güçlü yönleri bilme, zayıf yönleri kabul etme, gelişime açıklık.',
        'Değerlendirmeciler FARK EDER: Sahte özgüven genellikle sorgulandığında çöker.'
      ],
      keyPoints: [
        'Sahte = Abartılı iddialar',
        'Gerçek = Dengeli değerlendirme',
        'Zayıf yönleri kabul et',
        'Gelişime açık ol'
      ]
    }
  },
  'CM-M6-U3-L3': {
    lesson_id: 'CM-M6-U3-L3',
    title: 'Özgüven Egzersizleri',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Mülakat Öncesi Özgüven Artırma',
      paragraphs: [
        'Power Pose: Mülakattan önce 2 dakika güçlü duruş. Eller kalçada, omuzlar geri.',
        'Başarı Hatırlama: Geçmiş başarılarını düşün. "Bu işi de yapabilirim" de.',
        'Pozitif Affirmation: "Ben bu mülakat için hazırım" gibi cümleler tekrarla.',
        'Visualize: Başarılı mülakatı gözünde canlandır. Detayları hayal et.',
        'Nefes: 4-7-8 tekniği. 4 saniye nefes al, 7 saniye tut, 8 saniye ver.'
      ],
      keyPoints: [
        'Power Pose - 2 dakika',
        'Başarıları hatırla',
        'Pozitif cümleler tekrarla',
        '4-7-8 nefes tekniği'
      ]
    }
  },
  'CM-M6-U3-L4': {
    lesson_id: 'CM-M6-U3-L4',
    title: 'Senaryo: Özgüven Testi',
    type: 'scenario',
    duration: 8,
    xp: 40,
    scenario: {
      question: 'Değerlendirmeci: "Bu pozisyon için neden sizi seçmeliyiz?" En iyi cevap?',
      context: 'Birebir mülakatın sonuna yaklaşıyorsunuz.',
      options: [
        { id: 'A', text: '"Ben en iyi adayım, kimse benimle yarışamaz."', isCorrect: false },
        { id: 'B', text: '"Bilmiyorum, belki başkaları daha iyidir."', isCorrect: false },
        { id: 'C', text: '"Hizmet deneyimim ve öğrenme isteğim bu rol için uygun."', isCorrect: true },
        { id: 'D', text: '"Çok çalışkanım ve hiç hata yapmam."', isCorrect: false }
      ],
      feedback: {
        correct: 'Mükemmel! Dengeli özgüven. Somut güçlü yön + gelişime açıklık.',
        wrong: 'Hatalı. A kibirli, B özgüvensiz, D gerçekçi değil. C dengeli ve inandırıcı.'
      },
      explanation: 'İdeal cevap: 1) Somut güçlü yön, 2) Rol ile bağlantı, 3) Gelişime açıklık.'
    }
  },
  'CM-M6-U3-L5': {
    lesson_id: 'CM-M6-U3-L5',
    title: '🎮 Özgüven Doğru/Yanlış',
    type: 'truefalse',
    duration: 4,
    xp: 35,
    truefalse: {
      statements: [
        { statement: 'Özgüvenli olmak için kibir yapmak gerekir.', isTrue: false, explanation: 'Yanlış! Özgüven ≠ Kibir. Mütevazı ama emin ol.' },
        { statement: 'Power Pose özgüveni artırır.', isTrue: true, explanation: 'Doğru! 2 dakika güçlü duruş hormonları etkiler.' },
        { statement: 'Zayıf yönleri kabul etmek özgüvensizlik göstergesidir.', isTrue: false, explanation: 'Yanlış! Gerçek özgüven zayıf yönleri de kabul eder.' },
        { statement: '"Ben her şeyi yapabilirim" sahte özgüvendir.', isTrue: true, explanation: 'Doğru! Gerçekçi olmayan iddialar sahte özgüvendir.' },
        { statement: 'Göz teması özgüven göstergesidir.', isTrue: true, explanation: 'Doğru! Sakin göz teması özgüven yansıtır.' }
      ]
    }
  },

  // ==================== ÜNİTE 4: BEDEN DİLİ OKUMA ====================
  'CM-M6-U4-L1': {
    lesson_id: 'CM-M6-U4-L1',
    title: 'Beden Dili Temelleri',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Beden Dili Neden Önemli?',
      paragraphs: [
        'İletişimin %55\'i beden dili, %38\'i ses tonu, sadece %7\'si kelimeler.',
        'Değerlendirmeci sözlerinizi değil, NASIL söylediğinizi izler.',
        'Pozitif beden dili: Açık duruş, gülümseme, başla onaylama, öne hafif eğilme.',
        'Negatif beden dili: Kollar kavuşuk, bacak bacak üstüne, gözler kaçıyor, geriye yaslanma.',
        'Mirror (Aynalama): Karşınızdakinin duruşunu hafifçe taklit etmek empati gösterir.'
      ],
      keyPoints: [
        '%55 beden dili',
        'Açık duruş önemli',
        'Kollar kavuşuk = Kapalı',
        'Mirror tekniği kullan'
      ]
    }
  },
  'CM-M6-U4-L2': {
    lesson_id: 'CM-M6-U4-L2',
    title: 'El Hareketleri',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Eller Ne Söyler?',
      paragraphs: [
        'Eller görünür olmalı. Masanın üstünde, ceplerde değil.',
        'Avuç içi yukarı: Dürüstlük, açıklık. "Size açığım" mesajı.',
        'Avuç içi aşağı: Otorite, kontrol. Dikkatli kullan.',
        'Parmakla işaret: Agresif görünür. YAPMA!',
        'Çene tutma: Düşünce, değerlendirme. Doğal bırak.',
        'Saç/yüze dokunma: Gerginlik göstergesi. Fark et ve kontrol et.'
      ],
      keyPoints: [
        'Eller görünür olsun',
        'Avuç içi yukarı = Dürüstlük',
        'Parmakla işaret yapma',
        'Saça/yüze dokunmayı kontrol et'
      ]
    }
  },
  'CM-M6-U4-L3': {
    lesson_id: 'CM-M6-U4-L3',
    title: 'Yüz İfadeleri',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Yüz Okuma',
      paragraphs: [
        'Gülümseme: Doğal ol. Sahte gülümseme (sadece ağız) fark edilir. Gözler de gülsün.',
        'Göz teması: %60-70 göz teması ideal. %100 = Rahatsız edici. %0 = Güvensiz.',
        'Kaş kaldırma: İlgi ve şaşkınlık. Soru sorulurken hafifçe kaş kaldır.',
        'Dudak büzme: Hoşnutsuzluk. Farkında ol, yapma.',
        'Baş eğme: Dinleme, ilgi. Hafif baş eğerek dinle.'
      ],
      keyPoints: [
        'Doğal gülümseme',
        '%60-70 göz teması',
        'Baş eğerek dinle',
        'Sahte ifadelerden kaçın'
      ]
    }
  },
  'CM-M6-U4-L4': {
    lesson_id: 'CM-M6-U4-L4',
    title: 'Senaryo: Beden Dili',
    type: 'scenario',
    duration: 8,
    xp: 40,
    scenario: {
      question: 'Değerlendirmeci konuşurken hangi beden dili en uygun?',
      context: 'Grup mülakatında değerlendirmeci talimatları açıklıyor.',
      options: [
        { id: 'A', text: 'Kollar kavuşuk, arkaya yaslanıp dinlemek', isCorrect: false },
        { id: 'B', text: 'Hafif öne eğilip, başla onaylayarak dinlemek', isCorrect: true },
        { id: 'C', text: 'Not alırken hiç göz teması kurmamak', isCorrect: false },
        { id: 'D', text: 'Sürekli saate bakmak', isCorrect: false }
      ],
      feedback: {
        correct: 'Mükemmel! Hafif öne eğilme ve baş onayı aktif dinleme gösterir.',
        wrong: 'Hatalı. A kapalı duruş, C ilgisizlik, D sabırsızlık gösterir.'
      },
      explanation: 'Aktif dinleme = Öne eğil + Göz teması + Baş onayı + Not al (ara sıra bakarak).'
    }
  },
  'CM-M6-U4-L5': {
    lesson_id: 'CM-M6-U4-L5',
    title: '🎮 Beden Dili Eşleştir',
    type: 'matching',
    duration: 4,
    xp: 35,
    matching: {
      pairs: [
        { id: 1, left: 'Kollar kavuşuk', right: 'Kapalı/savunmacı' },
        { id: 2, left: 'Avuç içi yukarı', right: 'Dürüstlük/açıklık' },
        { id: 3, left: 'Öne eğilme', right: 'İlgi/merak' },
        { id: 4, left: 'Göz kaçırma', right: 'Güvensizlik' },
        { id: 5, left: 'Baş onayı', right: 'Aktif dinleme' }
      ]
    }
  },

  // ==================== ÜNİTE 5: DUYGUSAL ZEKA ====================
  'CM-M6-U5-L1': {
    lesson_id: 'CM-M6-U5-L1',
    title: 'Duygusal Zeka (EQ)',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'EQ Nedir?',
      paragraphs: [
        'EQ (Emotional Quotient): Duyguları anlama ve yönetme yeteneği.',
        'IQ kadar önemli, hatta daha önemli. Kabin ekibi için kritik.',
        'EQ bileşenleri: Öz farkındalık, öz yönetim, empati, sosyal beceriler.',
        'Öz farkındalık: Kendi duygularını tanıma. "Şu an gerginim" diyebilmek.',
        'Öz yönetim: Duyguları kontrol etme. Kızgınken sakin kalabilmek.'
      ],
      keyPoints: [
        'EQ = Duygusal Zeka',
        'Kabin ekibi için kritik',
        'Öz farkındalık + Empati',
        'Duygularını yönet'
      ]
    }
  },
  'CM-M6-U5-L2': {
    lesson_id: 'CM-M6-U5-L2',
    title: 'Empati Geliştirme',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Empati Nasıl Gösterilir?',
      paragraphs: [
        'Empati = Karşınızdakinin duygularını anlama. Sempati değil!',
        'Sempati: "Üzüldüm senin adına." (Dışarıdan)',
        'Empati: "Senin yerine olsam ben de böyle hissederdim." (İçeriden)',
        'Mülakatta empati: "Anlıyorum, bu durum zor olmalı" gibi ifadeler.',
        'Grup aktivitesinde: Diğer adayların fikirlerini dinle, değer ver.'
      ],
      keyPoints: [
        'Empati ≠ Sempati',
        'Karşıdakini gerçekten anla',
        '"Anlıyorum" de',
        'Fikirlere değer ver'
      ]
    }
  },
  'CM-M6-U5-L3': {
    lesson_id: 'CM-M6-U5-L3',
    title: 'Senaryo: Duygusal Durum',
    type: 'scenario',
    duration: 8,
    xp: 45,
    scenario: {
      question: 'Grup aktivitesinde bir aday çok sinirli ve agresif davranıyor. Ne yaparsınız?',
      context: 'Değerlendirmeciler izliyor.',
      options: [
        { id: 'A', text: 'Ona aynı şekilde agresif karşılık veririm', isCorrect: false },
        { id: 'B', text: 'Tamamen görmezden gelirim', isCorrect: false },
        { id: 'C', text: 'Sakin kalıp, nazikçe fikrini sorarım', isCorrect: true },
        { id: 'D', text: 'Değerlendirmeciye şikayet ederim', isCorrect: false }
      ],
      feedback: {
        correct: 'Harika! Sakin kalmak ve nazikçe dahil etmek hem EQ hem de liderlik gösterir.',
        wrong: 'Hatalı. Agresyona agresyon kötü, görmezden gelme ilgisizlik, şikayet çözüm değil.'
      },
      explanation: 'EQ ile yaklaşım: 1) Sakin kal, 2) Nedenini anlamaya çalış, 3) Nazikçe dahil et, 4) Örnek ol.'
    }
  },
  'CM-M6-U5-L4': {
    lesson_id: 'CM-M6-U5-L4',
    title: '⚡ EQ Zaman Yarışı',
    type: 'timerace',
    duration: 4,
    xp: 50,
    timerace: {
      timePerQuestion: 8,
      questions: [
        { q: 'EQ ne demek?', options: ['IQ', 'Duygusal Zeka', 'Eşitlik', 'Ekipman'], correct: 1 },
        { q: 'Empati ile sempati farkı?', options: ['Aynı', 'Empati içeriden', 'Sempati içeriden', 'Fark yok'], correct: 1 },
        { q: 'Öz farkındalık nedir?', options: ['Ayna', 'Kendi duygularını tanıma', 'Selfie', 'Kibir'], correct: 1 },
        { q: 'Agresif adaya ne yapılır?', options: ['Aynı davran', 'Şikayet et', 'Sakin kal', 'Git'], correct: 2 },
        { q: 'EQ kabin ekibi için?', options: ['Önemsiz', 'Kritik', 'Gereksiz', 'Lüks'], correct: 1 }
      ]
    }
  },

  // ==================== ÜNİTE 6: BAŞARISIZLIK YÖNETİMİ ====================
  'CM-M6-U6-L1': {
    lesson_id: 'CM-M6-U6-L1',
    title: 'Red Cevabı Almak',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Mülakatı Geçememek',
      paragraphs: [
        'Gerçek: Çoğu aday ilk mülakatında başarısız olur. Bu normal!',
        'THY her yıl binlerce başvuru alır, sadece yüzde birkaçı alınır.',
        'Red = Son değil. Yeniden başvurabilirsin. Gelişim fırsatı.',
        'Yapıcı yaklaşım: "Nerede hata yaptım?" sor. Öğren. Geliştir.',
        'Motivasyonu koruma: Hedefin değişmez, sadece yol değişir.'
      ],
      keyPoints: [
        'İlk red normal',
        'Yeniden başvur',
        'Hatadan öğren',
        'Motivasyonu koru'
      ]
    }
  },
  'CM-M6-U6-L2': {
    lesson_id: 'CM-M6-U6-L2',
    title: 'Growth Mindset',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Gelişim Odaklı Düşünce',
      paragraphs: [
        'Fixed Mindset: "Yeteneğim bu kadar. Değişemem." - YANLIŞ!',
        'Growth Mindset: "Her deneyim beni geliştirir. Öğrenebilirim." - DOĞRU!',
        'Mülakatta: "Daha önce bu konuda deneyimim yok ama hızlı öğrenirim."',
        'Red sonrası: "Neyi farklı yapabilirim?" diye sor, "Şansım yokmuş" deme.',
        'Havayolları growth mindset ister. Kabin ekibi sürekli öğrenmeli.'
      ],
      keyPoints: [
        'Fixed = Sabit düşünce',
        'Growth = Gelişim odaklı',
        '"Öğrenebilirim" de',
        'Havayolları growth ister'
      ]
    }
  },
  'CM-M6-U6-L3': {
    lesson_id: 'CM-M6-U6-L3',
    title: 'Senaryo: Zor Soru',
    type: 'scenario',
    duration: 8,
    xp: 45,
    scenario: {
      question: 'Değerlendirmeci: "Daha önce başvurdunuz ve red cevabı aldınız. Neden yeniden başvurdunuz?"',
      context: 'Bu soruyu soran havayolları, tutumunuzu test ediyor.',
      options: [
        { id: 'A', text: '"Geçen sefer haksız bir değerlendirme oldu."', isCorrect: false },
        { id: 'B', text: '"O zamandan beri eksiklerimi geliştirdim ve hazırım."', isCorrect: true },
        { id: 'C', text: '"Başka iş bulamadım."', isCorrect: false },
        { id: 'D', text: '"Artık daha şanslı olacağımı düşünüyorum."', isCorrect: false }
      ],
      feedback: {
        correct: 'Harika! Growth mindset. Hatayı kabul + gelişim + kararlılık.',
        wrong: 'Hatalı. A suçlama, C motivasyonsuzluk, D şansa bırakma. B ideal.'
      },
      explanation: 'Red sonrası cevap: 1) Red\'i kabul et, 2) Ne öğrendiğini söyle, 3) Nasıl geliştirdiğini anlat.'
    }
  },
  'CM-M6-U6-L4': {
    lesson_id: 'CM-M6-U6-L4',
    title: 'Ünite Sınavı',
    type: 'quiz',
    duration: 5,
    xp: 50,
    quiz: {
      questions: [
        { q: 'Growth mindset ne demek?', options: ['Büyümek', 'Gelişim odaklı düşünce', 'Zeka', 'Fizik'], correct: 1 },
        { q: 'Red cevabı alınca ne yapmalı?', options: ['Vazgeç', 'Şikayet et', 'Öğren ve geliştir', 'Unut'], correct: 2 },
        { q: 'Fixed mindset örneği?', options: ['"Öğrenebilirim"', '"Yeteneğim bu kadar"', '"Gelişirim"', '"Denerim"'], correct: 1 },
        { q: 'Mülakat başarısızlığı sonrası?', options: ['Son', 'Fırsat', 'Ceza', 'Utanç'], correct: 1 },
        { q: 'Red sorusuna en iyi cevap?', options: ['Şanssızdım', 'Haksızlık oldu', 'Geliştirdim', 'Bilmiyorum'], correct: 2 }
      ]
    }
  },

  // ==================== ÜNİTE 7: MÜLAKAT ÖNCESI HAZIRLIK ====================
  'CM-M6-U7-L1': {
    lesson_id: 'CM-M6-U7-L1',
    title: 'Bir Gün Önce',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Mülakattan Bir Gün Önce Yapılacaklar',
      paragraphs: [
        'Kıyafet: İrton önce hazırla. Ütülü, lekesiz, tam oturmalı.',
        'Belgeler: CV, fotoğraf, kimlik, diplomalar. Dosyada düzenli.',
        'Yol: Mülakat yerine nasıl gideceksin? Alternatif plan yap.',
        'Araştırma: Havayolu hakkında son haberleri oku. Yeni uçak, yeni rota vb.',
        'Erken yat: 7-8 saat uyku. Gece geç saatte çalışma!'
      ],
      keyPoints: [
        'Kıyafet hazırla',
        'Belgeleri düzenle',
        'Yolu planla',
        'Erken yat'
      ]
    }
  },
  'CM-M6-U7-L2': {
    lesson_id: 'CM-M6-U7-L2',
    title: 'Mülakat Sabahı',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Mülakat Sabahı Rutini',
      paragraphs: [
        'Erken kalk: Mülakattan 3-4 saat önce uyanmalısın.',
        'Kahvaltı: Hafif ama besleyici. Aşırı yeme, çok az da yeme.',
        'Hazırlık: Duş, saç, makyaj (hafif), kıyafet. 2 kez kontrol.',
        'Yola çık: En az 30-60 dakika erken ol. Trafik, park, güvenlik.',
        'Son kontrol: Telefon sessiz, belgeler tamam, gülümseme hazır!'
      ],
      keyPoints: [
        '3-4 saat önce uyan',
        'Hafif kahvaltı',
        '30-60 dk erken çık',
        'Telefon sessiz'
      ]
    }
  },
  'CM-M6-U7-L3': {
    lesson_id: 'CM-M6-U7-L3',
    title: 'Bekleme Odasında',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Bekleme Odası Davranışı',
      paragraphs: [
        'Dikkat: Değerlendirme bekleme odasında başlar! Her an izleniyorsun.',
        'Oturuş: Dik, profesyonel. Telefona gömülme.',
        'Diğer adaylar: Nazik ol ama çok samimi olma. Rakip değil, aday.',
        'Personel: Herkese nazik ol. Sekreter, güvenlik, temizlik...',
        'Son dakika: Tuvalete git, su iç, nefes egzersizi yap.'
      ],
      keyPoints: [
        'Bekleme odasında da izleniyorsun',
        'Dik otur, telefondan uzak',
        'Herkese nazik ol',
        'Son dakika hazırlığı'
      ]
    }
  },
  'CM-M6-U7-L4': {
    lesson_id: 'CM-M6-U7-L4',
    title: '🎮 Hazırlık Sıralaması',
    type: 'dragdrop',
    duration: 4,
    xp: 40,
    dragdrop: {
      instruction: 'Mülakat günü hazırlık sırasını belirleyin',
      items: [
        { text: '1️⃣ Erken uyan (3-4 saat önce)', order: 1 },
        { text: '2️⃣ Hafif kahvaltı yap', order: 2 },
        { text: '3️⃣ Kıyafet ve görünümü hazırla', order: 3 },
        { text: '4️⃣ Belgeleri son kez kontrol et', order: 4 },
        { text: '5️⃣ 30-60 dk erken yola çık', order: 5 }
      ]
    }
  },
  'CM-M6-U7-L5': {
    lesson_id: 'CM-M6-U7-L5',
    title: '⚡ Hazırlık Yarışı',
    type: 'timerace',
    duration: 4,
    xp: 45,
    timerace: {
      timePerQuestion: 7,
      questions: [
        { q: 'Mülakattan kaç saat önce uyanmalı?', options: ['1 saat', '2 saat', '3-4 saat', '30 dk'], correct: 2 },
        { q: 'Kahvaltı nasıl olmalı?', options: ['Çok ağır', 'Hafif ve besleyici', 'Hiç yeme', 'Sadece kahve'], correct: 1 },
        { q: 'Mülakat yerine ne zaman varılmalı?', options: ['Tam zamanında', '5 dk önce', '30-60 dk önce', '2 saat önce'], correct: 2 },
        { q: 'Bekleme odasında ne yapılmamalı?', options: ['Dik oturma', 'Telefona gömülme', 'Gülümseme', 'Nefes alma'], correct: 1 },
        { q: 'Bekleme odasında kim izliyor?', options: ['Kimse', 'Sadece adaylar', 'Değerlendirmeciler', 'Polis'], correct: 2 }
      ]
    }
  }
};

export default cabinCrewContentsM6Extra;
